import { render, staticRenderFns } from "./collectionRateDetail.vue?vue&type=template&id=748d7e20&"
import script from "./collectionRateDetail.vue?vue&type=script&lang=js&"
export * from "./collectionRateDetail.vue?vue&type=script&lang=js&"
import style0 from "./collectionRateDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports